<template>
  <v-btn
    class="dialog-close-button-position z-index-1"
    color="#e21b23"
    @click="close"
    icon
  >
    <v-icon>mdi-close</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "CloseDialogButton",
  props: {
    close: Function,
  },
};
</script>

<style scoped>
.dialog-close-button-position {
  position: absolute;
  right: 16px;
  top: 16px;
}
</style>
